import React, { FC, PropsWithChildren } from 'react'
import Box from '@mui/material/Box'
import { HasSidebarLayout, DataLoad, ListHeader, PropsInjector, SensorList, SearchForm, SwitchView, ExportSensorLocationData, UploadSensors } from 'src/components'
import { useSensorStatesRequest, useSensorTypesRequest } from 'src/hooks/api'
import { HiddenMapProvider } from 'src/components/providers'
import { useQueryParamsState } from 'src/hooks/ui'

const SensorTypeLoader: FC<PropsWithChildren> = ({ children }) => {
  const { data, isInitialLoading, isError } = useSensorTypesRequest()
  const lorawanSensorType = data?.rows?.find((type) => type.name === 'jobsite_conditions_monitor')
  const typeId = lorawanSensorType?.id

  return (
    <DataLoad isLoading={isInitialLoading} isError={isError}>
      <PropsInjector props={{ typeId }}>{children}</PropsInjector>
    </DataLoad>
  )
}

const SensorStateLoader: FC<PropsWithChildren<{ typeId?: number }>> = ({ typeId, children }) => {
  const { data, isInitialLoading, isError } = useSensorStatesRequest()
  return (
    <DataLoad isLoading={isInitialLoading} isError={isError}>
      <PropsInjector props={{ states: data || [], typeId }}>{children}</PropsInjector>
    </DataLoad>
  )
}

const SensorListPage: FC = () => {
  const queryParams = useQueryParamsState()
  const state = queryParams.state
  const isVisibleSwitchView: boolean = !['thingspace', 'diagnostics', 'verizon-reports', 'unused-sensor'].includes(state)
  const isVisibleExport: boolean = !['verizon-reports', 'unused-sensor'].includes(state)
  document.title = 'CLīMIT Admin Panel - Sensors'
  return (
    <HasSidebarLayout>
      <ListHeader title="Sensors">
        {isVisibleExport ? <UploadSensors /> : null}
        {isVisibleExport ? <ExportSensorLocationData /> : null}
        {isVisibleSwitchView ? <SwitchView /> : null}
      </ListHeader>
      <HiddenMapProvider>
        <Box mb={2}>
          <SearchForm multiline placeholder="Search one sensor, or paste several IMEIs / IDs separated by spaces, commas or new lines" />
        </Box>
        <SensorTypeLoader>
          <SensorStateLoader>
            <SensorList />
          </SensorStateLoader>
        </SensorTypeLoader>
      </HiddenMapProvider>
    </HasSidebarLayout>
  )
}

export default SensorListPage
